export const HOME_TDK = {
  title: '大雷影视大全_最新电影电视剧推荐',
  description:
    '大雷影视平台收录最新电影和电视剧，提供丰富影视内容介绍和资讯，帮助用户轻松找到喜爱的影视作品。',
  keywords: '大雷,影视,电影推荐,电视剧,影视资讯,影视平台,影视大全',
};

export const SITE_NAME = '大雷影视';

export const CONTACT_EMAIL = 'contact@daleifilm.example.com';

export const NAV_LINKS = [
  { label: '首页', path: '/' },
  { label: '电影', path: '/category/movie' },
  { label: '电视剧', path: '/category/tv' },
  { label: '专题', path: '/special/special-01' },
  { label: '关于', path: '/about' },
];